import { composeIO } from 'react-compose-io'
import { DetalheDebitoView } from './DetalheDebito.View'
import { detalheDebitoIO } from './DetalheDebito.IO'

export const DetalheDebito = composeIO(DetalheDebitoView, detalheDebitoIO)
